"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";
import Link from "next/link";

export const CustomizationButton = () => {
  const { customizationsButton } = useTranslations();

  return (
    <div className="w-full flex justify-center mt-10">
      <Link href="/classic-customizations" target="_blank" className="btn-yellow-arrow">
        <span>{customizationsButton}</span>
      </Link>
    </div>
  );
};
